module.exports = __webpack_public_path__ + "media/images/about/about-image3-1e6e9e991063324489854e23cc0bbbcd.jpg";